import { lazy, Suspense, useState } from 'react';
import { CircleHelp } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { Spinner } from '@/components/ui/spinner';

// The guide library is loaded only when someone asks for help.
const HelpContent = lazy(() => import('@/pages/knowledge-base/help-content'));

export function KnowledgeHelp() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="shrink-0"
          aria-label="Help for this page"
          title="Help for this page"
          data-testid="knowledge-help-button"
        >
          <CircleHelp className="h-5 w-5" />
        </Button>
      </SheetTrigger>
      <SheetContent className="w-full overflow-y-auto sm:max-w-xl">
        <SheetHeader className="pr-6 text-left">
          <SheetTitle>Help for this page</SheetTitle>
          <SheetDescription>
            Visual guides and step-by-step instructions for the WMS.
          </SheetDescription>
        </SheetHeader>
        {open && (
          <Suspense
            fallback={
              <div className="flex items-center gap-2 py-8" role="status">
                <Spinner size="sm" /> Loading guides…
              </div>
            }
          >
            <HelpContent
              pathname={pathname}
              onNavigate={() => setOpen(false)}
            />
          </Suspense>
        )}
      </SheetContent>
    </Sheet>
  );
}
